import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function TreatmentAreasSection() {
  const {
    t
  } = useLanguage();
  const areas = [{
    title: t('treatment.nasolabial'),
    description: t('treatment.nasolabialDesc'),
    points: ['Immediate volume restoration', 'Natural facial expressions', 'Lasts up to 12 months']
  }, {
    title: t('treatment.lips'),
    description: t('treatment.lipsDesc'),
    points: ['Soft, natural feel', "Enhanced cupid's bow", 'Reduced perioral lines']
  }, {
    title: t('treatment.cheeks'),
    description: t('treatment.cheeksDesc'),
    points: ['High lifting capacity', 'Restores youthful triangle', 'Lasts up to 18 months']
  }, {
    title: t('treatment.jawline'),
    description: t('treatment.jawlineDesc'),
    points: ['Sharpens facial contours', 'Improves facial harmony', 'Non-surgical alternative']
  }];
  return <section id="treatment-areas" className="py-24 bg-white" data-id="element-444">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-445">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-446">
          {/* Left: Illustration/Image */}
          <div className="order-2 lg:order-1 relative" data-id="element-447">
            <div className="aspect-square rounded-full overflow-hidden relative border-8 border-white shadow-xl" data-id="element-448">
              <img src="https://cdn.magicpatterns.com/uploads/sP6G7aCd5bqaj2bAFs6PPc/freepik_assistant_1775664309126.png" alt="Beautiful Asian model portrait" className="w-full h-full object-cover" data-id="element-449" />

              {/* Treatment area indicator dots with labels */}
              {/* Forehead */}
              <div className="absolute top-[22%] left-[44%] flex items-center gap-1.5 group" data-id="element-450">
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" data-id="element-451"></div>
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-452">
                  {t('treatment.forehead') || 'Forehead'}
                </span>
              </div>

              {/* Nasolabial Folds */}
              <div className="absolute top-[53%] left-[28%] flex items-center gap-1.5" data-id="element-453">
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-454">
                  {t('treatment.nasolabial')}
                </span>
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '0.4s'
              }} data-id="element-455"></div>
              </div>

              {/* Lips */}
              <div className="absolute top-[60%] left-[42%] flex items-center gap-1.5" data-id="element-456">
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '0.8s'
              }} data-id="element-457"></div>
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-458">
                  {t('treatment.lips')}
                </span>
              </div>

              {/* Cheeks */}
              <div className="absolute top-[46%] left-[58%] flex items-center gap-1.5" data-id="element-459">
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '1.2s'
              }} data-id="element-460"></div>
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-461">
                  {t('treatment.cheeks')}
                </span>
              </div>

              {/* Jawline / Chin */}
              <div className="absolute top-[70%] left-[34%] flex items-center gap-1.5" data-id="element-462">
                <span className="text-[10px] font-semibold text-white bg-brand-copper/80 backdrop-blur-sm px-2 py-0.5 rounded-full whitespace-nowrap shadow-md" data-id="element-463">
                  {t('treatment.jawline')}
                </span>
                <div className="w-3.5 h-3.5 bg-brand-copper rounded-full shadow-[0_0_12px_rgba(40,99,147,0.8)] animate-pulse border-2 border-white" style={{
                animationDelay: '1.6s'
              }} data-id="element-464"></div>
              </div>
            </div>
            {/* Background decoration */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-brand-lightCopper/20 rounded-full -z-10 blur-3xl" data-id="element-465"></div>
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-brand-copper/10 rounded-full -z-10 blur-3xl" data-id="element-466"></div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2" data-id="element-467">
            <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-468">
              {t('treatment.label')}
            </h2>
            <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 leading-tight" data-id="element-469">
              {t('treatment.title1')}{' '}
              <span className="font-semibold" data-id="element-470">{t('treatment.title2')}</span>
            </h3>
            <p className="text-gray-600 mb-10 leading-relaxed" data-id="element-471">
              {t('treatment.subtitle')}
            </p>

            <div className="space-y-8" data-id="element-472">
              {areas.map((area, index) => <div key={index} className="flex" data-id="element-473">
                  <div className="flex-shrink-0 mt-1" data-id="element-474">
                    <div className="w-8 h-8 rounded-full bg-brand-lightCopper/50 flex items-center justify-center text-brand-darkCopper font-semibold text-sm" data-id="element-475">
                      0{index + 1}
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-476">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-477">
                      {area.title}
                    </h4>
                    <p className="text-gray-600 text-sm mb-3" data-id="element-478">
                      {area.description}
                    </p>
                    <ul className="flex flex-wrap gap-2" data-id="element-479">
                      {area.points.map((point, idx) => <li key={idx} className="text-xs font-medium bg-gray-100 text-gray-600 px-2 py-1 rounded" data-id="element-480">
                          {point}
                        </li>)}
                    </ul>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}